<template>
  <Card class="map-card">
    <div class="text-xs-center pt-3 pb-3">
      CHARGE / DISCHARGE SETTINGS
    </div>
    <v-divider class="custom-divider" />
    <div class="mt-4">
      <v-layout row wrap align-center>
        <v-flex xs6 class="py-3 text-xs-center" v-for="(config, key) in m2mFeMapEMC" :key="key">
          <div class="caption">{{ config.name }}</div>
          <div v-if="content && content[key] != null">
            <span class="value">{{ content[key] }}</span>
            <span v-if="config.unit" class="unit"> {{ config.unit }}</span>
          </div>
          <span v-else class="na-value">N/A</span>
        </v-flex>
      </v-layout>
    </div>
  </Card>
</template>

<script>
export default {
  name: "SettingsCard",
  props: {
    content: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      m2mFeMapEMC: {
        control_mode: { name: "Mode", unit: "" },
        max_dischrg_pwr: { name: "Discharge threshold", unit: "kW" },
        max_chrg_pwr: { name: "Charge threshold", unit: "kW" },
        pcs_status: { name: "PCS Status", unit: "" },
        battery_status: { name: "Battery Status", unit: "" },
      },
    }
  }
};
</script>

<style scoped>
.map-card {
  height: 400px;
  border: 1px solid #334079 !important;
  border-radius: 8px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.value {
  font-size: 20px;
  font-weight: 700;
  color: #668cf6;
  line-height: 1;
}

.unit {
  font-size: 14px;
  color: #fff;
  margin-left: 2px;
}

.na-value {
  font-size: 20px;
  font-weight: 700;
  color: #ff5252;
}

.custom-divider {
  border-color: #334079 !important;
}

.caption {
  font-size: 0.85rem;
  margin-bottom: 4px;
}

.theme--dark .caption {
  color: var(--v-grey-base);
}

.theme--light .caption {
  color: var(--v-secondaryText-base);
}
</style>
